import { useEffect, useState } from "react";
import FormTypeDropdown from "./FormTypeDropdown";
import CustomerDropDown from "src/Pages/WO/Components/dropdown/customerdropdown";
import CustomerService from "src/Services/API/customer.service";
import { handleError } from "src/Common/function";

const FormTemplateFilterView = ({ onApply, onClear }) => {
  const [filterType, setFilterType] = useState("");
  const [filterCustomerId, setFilterCustomerId] = useState("");
  const [filterCustomerName, setFilterCustomerName] = useState("Select");
  const [customers, setCustomers] = useState([]);
  const [customerNames, setCustomerNames] = useState([]);
  const [customerKeyword, setCustomerKeyword] = useState("");

  useEffect(() => {
    CustomerService.getAll(customerKeyword)
      .then((response) => {
        if (response.status === 200) {
          setCustomers(response.data);
          setCustomerNames(response.data.map((item) => item.companyName));
        }
      })
      .catch((error) => handleError(error));
  }, [customerKeyword]);

  const handleCustomerSelect = (index) => {
    if (!customers[index]) return;
    setFilterCustomerId(String(customers[index].id));
    setFilterCustomerName(customers[index].companyName);
  };

  const handleApply = () => {
    onApply({
      filterType,
      customerId: filterCustomerId,
    });
  };

  const handleClear = () => {
    setFilterType("");
    setFilterCustomerId("");
    setFilterCustomerName("Select");
    setCustomerKeyword("");
    onClear();
  };

  return (
    <div className="flex items-center gap-6 pb-4">
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by Type:
        </span>
        <div className="w-[200px]">
          <FormTypeDropdown
            selectedValue={filterType !== "" ? Number(filterType) : null}
            onSelect={(val) => setFilterType(String(val))}
          />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-OpenSansMedium font-[600] text-titleColor whitespace-nowrap">
          by Customer:
        </span>
        <div className="w-[220px]">
          <CustomerDropDown
            options={customerNames}
            defaultOption={filterCustomerName}
            onSelect={handleCustomerSelect}
            keywordChanged={setCustomerKeyword}
          />
        </div>
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <div
          onClick={handleApply}
          className="px-5 h-[24px] text-[10px] rounded-[4px] bg-blueColor text-white font-OpenSansRegular font-[600] flex items-center justify-center cursor-pointer"
        >
          APPLY
        </div>
        <div
          onClick={handleClear}
          className="px-5 h-[24px] text-[10px] rounded-[4px] border-[1px] border-borderColor text-[#67737E] font-OpenSansRegular font-[600] flex items-center justify-center cursor-pointer"
        >
          CLEAR
        </div>
      </div>
    </div>
  );
};

export default FormTemplateFilterView;
